import { tv } from "tailwind-variants";

export const getContainerClass = tv({ base: "container" });
